import {URL_BASE_API } from '../../../configs/urlConfigs'; 

import service from '../../api';

export const certificatesList = (request) => {
    let ENDPOINT = URL_BASE_API+'affiliate/expiring-crew-ceritificates/';
    let sepVal = '?'; 
    // ?column=crew_skill__affiliate_skill__skill_name&duration=30
    if(request.data) {
        if(request.data.sortBy && request.data.sortBy.length) {
            ENDPOINT += sepVal+'column='+request.data.sortBy; 
            sepVal = '&'
        }
        if(request.data.duration >=0) {
            ENDPOINT += sepVal+'duration='+request.data.duration; 
            sepVal = '&'
        }
        let search = request.data.search && request.data.search.length ? request.data.search : ''; 
        ENDPOINT += sepVal+'expired_certificates='+request.data.expiredCertificates+'&search='+search; 
    }
    return service.get(ENDPOINT);    
}; 


